import React, { useEffect, useState } from "react"
import { useNavigate } from "react-router-dom"
import Breadcrumbs from "../../../components/Common/Breadcrumb"
import {
  Container,
  Table,
  Row,
  Col,
  Nav,
  NavItem,
  NavLink,
  TabContent,
  TabPane,
  Form,
  Collapse,
} from "reactstrap"
import classnames from "classnames"
import configure from "configure"

// components
import Credentials from "./Credentials"
import Loader from "pages/Separate/Loader"
import axios from "axios"
import Swal from "sweetalert2"
import GeneralTaskSetting from "./GeneralTaskSetting/GeneralTaskSetting"
import AccessActivityIndex from "./GeneralTaskSetting/AccessActivityIndex"
import LeadCommunicatorIndex from "./GeneralTaskSetting/LeadCommunicatorIndex"
import CalenderAccessIndex from "./GeneralTaskSetting/Calendar Access/CalendarAccessIndex"
import ManageAiKeyIndex from "./GeneralTaskSetting/ManageAiKeyIndex";
import AlertSettingsIndex from "./AlertSettings/AlertSettingsIndex";
import AssessmentViewSettings from "./AssessmentViewSettings";

import LinkedinIndex from "../Linkedin"
import { fetchNodeData } from "utils/common-fetchData"
import { useDispatch, useSelector } from "react-redux"
import { setGeneralData } from "store/actions"
import { transformGeneralData } from "utils/common-helpers"
import secureLocalStorage from "react-secure-storage"

const GeneralSettingIndex = () => {
  const [verticalActiveTab, setverticalActiveTab] = useState("1")
  const [fixedSideTab, setFixedSideTab] = useState(false)
  const [fixedContent, setFixedContent] = useState(false)
  const [swalconfirm, setSwalconfirm] = useState(false)
  const [testingRows, setTestingRows] = useState([])
  const [isShowCred, setIsShowCred] = useState(null)

  const [inputData, setInputData] = useState([])

  const [currency, setCurrency] = useState([])

  const [dynamicObj, setDynamicObj] = useState({})
  const [isLoading, setLoading] = useState(false)

  const [technology_id, setTechnoId] = useState(null)
  const [globalFilter, setGlobalFilter] = useState("")
  const [searchTerm, setSearchTerm] = useState("")
  const [rowData, setRowData] = useState([])
  // const [pageSize, setPageSize] = useState(10)
  const [isSubNavOpen, setIsSubNavOpen] = useState(false)

  // Overhead specific state
  const [staffCount, setStaffCount] = useState("");
  const [overheadRows, setOverheadRows] = useState([])
  const [overheadLoading, setOverheadLoading] = useState(false)
  const [overheadSearch, setOverheadSearch] = useState("")
  const [overheadRawData, setOverheadRawData] = useState([])
  const [selectedOverheadCurrency, setSelectedOverheadCurrency] = useState("")

  const navigate = useNavigate()
  const dispatch = useDispatch()
  const generalData = useSelector(state => state?.GeneralData?.generalData)

  useEffect(() => {
    fetchCurrency()
    fetchStaffCount()
    // Staff dropdowns in the LinkedIn and Calendar Access tabs read from Redux
    // generalData, which is otherwise only loaded by the General Task dashboard.
    if (!generalData?.users?.length) fetchGeneralData()
  }, [])

  async function fetchGeneralData() {
    const res = await fetchNodeData(null, "generalData", secureLocalStorage.getItem("auth_token"))
    if (res?.success && res?.data) {
      dispatch(setGeneralData(transformGeneralData(res.data)))
    }
  }

  useEffect(() => {
    setInputData(inputData?.map((item, index) => ({ ...item, id: index + 1 })))
    // console.log("checking", inputData)
  }, [testingRows])


  async function fetchStaffCount() {
    const response = await fetchNodeData(setLoading, "staff")
    if (response?.success) {
      setStaffCount(response?.data?.filter(item => item?.overhead == 1).length)
    }
  }

  const fetchCurrency = async () => {
    try {
      await axios({
        method: "get",
        url: `${configure.nodeApi}/currency`,

        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
      }).then(res => {
        console.log("currency", res.data)
        setCurrency(res.data.currency)
        showTechnologiesData()
        setSelectedOverheadCurrency(res?.data?.currency?.[1]?.currency)

        // =============
        const temp = {}
        res.data.currency.forEach(obj => {
          temp[obj.currency] = ""
        })

        setDynamicObj(temp)
        setInputData([{ id: 1, Technology: "", status: "optional", ...temp }])
        setTestingRows([{ id: 1 }])

        // call show api

      })
    } catch (error) { }
  }

  const showTechnologiesData = async () => {
    setLoading(true)
    try {
      const response = await axios({
        method: "get",
        url: `${configure.nodeApi}/show_technologies`,
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
      }).then(async response => {
        // console.log('data', response)
        if (response.data.data.length > 0) {
          const rawValue = response.data.data[0].currency_value
          let datas = rawValue
          if (typeof rawValue === "string") {
            try {
              datas = JSON.parse(rawValue)
            } catch (e) {
              datas = []
            }
          }
          if (Array.isArray(datas)) {
            setRowData(datas)
            let tempRows = []
            datas.forEach(item => {
              tempRows.push({ id: item.id })
            })
            setTestingRows(tempRows)
            setInputData(datas)
            setTechnoId(response.data.data[0].id)
          }
        }
        setLoading(false)
        // response.data.data[0].currency_value
      })
    } catch (err) {
      console.log(err)
      setLoading(false)
    }
  }

  const STATUS_OPTIONS = ["optional", "default", "BA", "QA"]
  const UNIQUE_STATUSES = ["default", "BA", "QA"]

  // form repeater
  const onAddRow = () => {
    const modifiedRows = [...testingRows]
    modifiedRows.push({ id: modifiedRows.length + 1 })
    setTestingRows(modifiedRows)

    setInputData([
      ...inputData,
      // {
      //   id: modifiedRows.length,
      //   Technology: "",
      //   ...dynamicObj,
      // },
      {
        id: modifiedRows.length,
        Technology: "",
        status: "optional",
        ...dynamicObj,
      },
    ])
  }

  const onDeleteRow = id => {
    Swal.fire({
      icon: "warning",
      title: "Are You Sure ?",
      text: "You want to Delete this Technologies !",
      showCancelButton: true,
    }).then(willDelete => {
      if (willDelete.isConfirmed) {
        Swal.fire({
          icon: "success",
          text: "Technologies deleted successfully !",
        }).then(() => {
          var modifiedRows = [...testingRows]
          modifiedRows = modifiedRows.filter(x => x["id"] !== id)
          setTestingRows(
            modifiedRows.map((item, index) => ({ ...item, id: index + 1 }))
          )
          setInputData(prevForms => {
            const updatedForms = [...prevForms]
            return updatedForms.filter((serv, i) => serv.id !== id)
          })
        })
      }
    })
  }
  // ==================================
  const handleFormChange = (index, field, value) => {
    setInputData(prev => {
      const updated = prev.map(row => ({ ...row }))
      if (field === "status" && UNIQUE_STATUSES.includes(value)) {
        updated.forEach((row, idx) => {
          if (idx !== index && row.status === value) {
            updated[idx] = { ...row, status: "optional" }
          }
        })
      }
      updated[index] = { ...updated[index], [field]: value }
      return updated
    })
  }
  // ==================================

  document.addEventListener("scroll", () => {
    if (window.scrollY > 165) {
      setFixedContent(true)
    } else {
      setFixedContent(false)
    }
  })
  document.addEventListener("scroll", () => {
    if (window.scrollY > 68) {
      setFixedSideTab(true)
    } else {
      setFixedSideTab(false)
    }
  })

  document.title = "General Settings  | Zithas Crm"

  const toggleVertical = tab => {
    if (verticalActiveTab !== tab) {
      setverticalActiveTab(tab)
    }
  }

  // Add /Edit Technologies api integration
  const addEditTechnologies = async e => {
    e.preventDefault()
    setLoading(true)
    const formData = new FormData()

    if (technology_id) {
      formData.append("technologies_id", technology_id)
    }
    formData.append("currency_value", JSON.stringify(inputData))

    try {
      const response = await axios({
        method: "post",
        url: `${configure.nodeApi}/add_technologies`,
        data: formData,
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
      })

      // console.log("add", response)

      if (response) {
        setSwalconfirm(true)
        setLoading(false)
        const datas = JSON.parse(response.data.data[0].currency_value)
        let tempRows = []
        datas.forEach(item => {
          tempRows.push({ id: item.id })
        })
        setTestingRows(tempRows)
        setInputData(datas)
      }
    } catch (error) {
      console.log(error)
      setLoading(false)
    }
  }

  const filterGlobel = () => {
    const filteredDatas = rowData?.filter(
      item =>
        item.Technology &&
        item.Technology.toLowerCase().includes(searchTerm.toLowerCase())
    )
    let tempRows = []
    filteredDatas.forEach(item => {
      tempRows.push({ id: item.id })
    })
    setTestingRows(tempRows)
    setInputData(filteredDatas)
  }
  useEffect(() => {
    filterGlobel()
  }, [searchTerm])

  // table



  const DURATION_OPTIONS = [
    { label: "Hourly", value: "hourly" },
    { label: "Monthly", value: "monthly" },
    { label: "2 Months", value: "2_months" },
    { label: "3 Months", value: "3_months" },
    { label: "6 Months", value: "6_months" },
    { label: "Yearly", value: "yearly" },
  ]

  // GBP auto-calculation
  const calculateGBP = (duration, amount) => {
    const amt = parseFloat(amount) || 0
    switch (duration) {
      case "hourly":
        return amt
      case "monthly":
        return amt / 730
      case "2_months":
        return amt / (730 * 2)
      case "3_months":
        return amt / (730 * 3)
      case "6_months":
        return amt / (730 * 6)
      case "yearly":
        return amt / (730 * 12)
      default:
        return amt
    }
  }

  // Fetch all overheads on tab open
  const fetchOverheads = async () => {
    setOverheadLoading(true)
    try {
      const res = await axios.get(`${configure.nodeApi}/overheads`)
      if (res.data.success) {
        // API returns lowercase keys (e.g. "gbp"), map them to currency state
        // keys (e.g. "GBP") so the currency inputs populate correctly
        const normalized = res.data.data.map(row => {
          const normalizedRow = { ...row }
          currency.forEach(c => {
            if (normalizedRow[c.currency] === undefined) {
              const lowerKey = c.currency.toLowerCase()
              if (normalizedRow[lowerKey] !== undefined) {
                normalizedRow[c.currency] = normalizedRow[lowerKey]
              }
            }
          })
          return normalizedRow
        })
        setOverheadRows(normalized)
        setOverheadRawData(normalized)
      }
    } catch (err) {
      console.error("fetchOverheads error:", err)
    } finally {
      setOverheadLoading(false)
    }
  }

  useEffect(() => {
    if (verticalActiveTab === "12") fetchOverheads()
  }, [verticalActiveTab])

  // Add a blank row locally
  const onAddOverheadRow = () => {
    setOverheadRows(prev => [
      ...prev,
      {
        id: null,
        name: "",
        duration: "hourly",
        amount: "",
        gbp: "",
        ...dynamicObj,
      },
    ])
  }

  // Handle field change + auto-calculate GBP
  const handleOverheadChange = (index, field, value) => {
    setOverheadRows(prev => {
      const updated = [...prev]
      updated[index] = { ...updated[index], [field]: value }

      // recalculate GBP whenever amount or duration changes
      if (field === "amount" || field === "duration") {
        const amt = field === "amount" ? value : updated[index].amount
        const duration = field === "duration" ? value : updated[index].duration
        updated[index].gbp = parseFloat(calculateGBP(duration, amt)).toFixed(2)
      }

      return updated
    })
  }

  // Save individual row (create or update)
  const saveOverheadRow = async (row, index) => {
    if (!row.name) return Swal.fire("Error", "Name is required", "error")
    // if (!row.duration)
    //   return Swal.fire("Error", "Duration is required", "error");
    // if (!row.amount) return Swal.fire("Error", "Amount is required", "error");

    setOverheadLoading(true)
    const currencyData = {}
    currency.forEach(c => {
      currencyData[c.currency.toLowerCase()] = row[c.currency] || ""
    })
    try {
      let res
      if (row.id) {
        // Update existing
        res = await axios.put(`${configure.nodeApi}/overhead/${row.id}`, {
          name: row.name,
          duration: row.duration,
          amount: row.amount,
          gbp: row.gbp,
          ...currencyData,
        })
      } else {
        // Create new
        res = await axios.post(`${configure.nodeApi}/overhead`, {
          name: row.name,
          duration: row.duration,
          amount: row.amount,
          gbp: row.gbp,
          ...currencyData,
        })
      }

      if (res.data.success) {
        Swal.fire({
          icon: "success",
          title: "Saved!",
          text: "Overhead saved successfully.",
          timer: 1500,
          showConfirmButton: false,
        })
        fetchOverheads() // refresh from server
      }
    } catch (err) {
      console.error("saveOverheadRow error:", err)
      Swal.fire("Error", "Something went wrong", "error")
    } finally {
      setOverheadLoading(false)
    }
  }

  // Delete individual row
  const deleteOverheadRow = async (row, index) => {
    Swal.fire({
      icon: "warning",
      title: "Are You Sure?",
      text: "You want to delete this Overhead!",
      showCancelButton: true,
    }).then(async result => {
      if (result.isConfirmed) {
        // If not yet saved to DB, just remove locally
        if (!row.id) {
          setOverheadRows(prev => prev.filter((_, i) => i !== index))
          return
        }
        try {
          const res = await axios.delete(
            `${configure.nodeApi}/overhead/${row.id}`
          )
          if (res.data.success) {
            Swal.fire({
              icon: "success",
              text: "Overhead deleted successfully!",
              timer: 1500,
              showConfirmButton: false,
            })
            fetchOverheads()
          }
        } catch (err) {
          console.error("deleteOverheadRow error:", err)
        }
      }
    })
  }

  // Search filter
  const filteredOverheadRows = overheadRows.filter(row =>
    row.name?.toLowerCase().includes(overheadSearch.toLowerCase())
  )

  return (
    <React.Fragment>
      {isLoading && <Loader />}
      <div className="page-content mb-4">
        <Container fluid>
          <Breadcrumbs
            title={"Dashboard"}
            breadcrumbItem={"General Settings"}
          />

          <Row className="gx-4 justify-content-between di-flex align-items-top">
            <Col md="2" className="px-0">
              <Nav
                pills
                className={`side-tab flex-column px-2 py-3
                            ${fixedSideTab ? "fixed-side-tab" : ""} h-100`}
              >
                <NavItem>
                  <NavLink
                    style={{ cursor: "pointer" }}
                    className={classnames({
                      "mb-2": true,
                      active: verticalActiveTab === "1",
                    })}
                    onClick={() => {
                      toggleVertical("1")
                    }}
                  >
                    Credentials
                  </NavLink>
                </NavItem>

                <NavItem>
                  <NavLink
                    style={{ cursor: "pointer" }}
                    className={classnames({
                      "mb-2": true,
                      active: verticalActiveTab === "2",
                    })}
                    onClick={() => {
                      toggleVertical("2")
                    }}
                  >
                    Gitlab
                  </NavLink>
                </NavItem>
                <NavItem>
                  <NavLink
                    style={{ cursor: "pointer" }}
                    className={classnames({
                      "mb-2": true,
                      active: verticalActiveTab === "3",
                    })}
                    onClick={() => {
                      toggleVertical("3")
                    }}
                  >
                    Technologies
                  </NavLink>
                </NavItem>
                <NavItem>
                  <NavLink
                    style={{ cursor: "pointer" }}
                    className={classnames({
                      "mb-2": true,
                      active: verticalActiveTab === "12",
                    })}
                    onClick={() => {
                      toggleVertical("12")
                    }}
                  >
                    Overhead
                  </NavLink>
                </NavItem>
                <NavItem>
                  <NavLink
                    style={{ cursor: "pointer" }}
                    className={classnames({
                      "mb-2": true,
                      // active: verticalActiveTab === "4",
                    })}
                    onClick={() => {
                      // setVerticalActiveTab("4");
                      setIsSubNavOpen(true) // Ensure the sub-nav remains open
                    }}
                  >
                    General Task
                    <span
                      style={{
                        marginLeft: "auto",
                        display: "inline-flex",
                        alignItems: "center",
                      }}
                    >
                      {isSubNavOpen ? (
                        <i className="bi bi-caret-up-fill ms-2"></i>
                      ) : (
                        <i className="bi bi-caret-down-fill ms-2"></i>
                      )}
                    </span>
                  </NavLink>

                  <Collapse isOpen={isSubNavOpen}>
                    <Nav className="ms-3 d-flex flex-column general-tak">
                      <NavItem>
                        <NavLink
                          style={{ cursor: "pointer" }}
                          className={classnames({
                            active: verticalActiveTab === "5",
                          })}
                          onClick={e => {
                            e.stopPropagation()
                            toggleVertical("5")
                          }}
                        >
                          Create Task
                        </NavLink>
                      </NavItem>

                      <NavItem>
                        <NavLink
                          style={{ cursor: "pointer" }}
                          className={classnames({
                            active: verticalActiveTab === "6",
                          })}
                          onClick={e => {
                            e.stopPropagation()
                            toggleVertical("6")
                          }}
                        >
                          Access Activities
                        </NavLink>
                      </NavItem>
                      <NavItem>
                        <NavLink
                          style={{ cursor: "pointer" }}
                          className={classnames({
                            active: verticalActiveTab === "9",
                          })}
                          onClick={e => {
                            e.stopPropagation() // Prevent parent toggle
                            toggleVertical("9") // Set active state for this tab only
                          }}
                        // Does not affect `isSubNavOpen`
                        >
                          Lead Communicator
                        </NavLink>
                      </NavItem>
                    </Nav>
                  </Collapse>
                </NavItem>
                <NavItem>
                  <NavLink
                    style={{ cursor: "pointer" }}
                    className={classnames({
                      active: verticalActiveTab === "10",
                    })}
                    onClick={e => {
                      e.stopPropagation() // Prevent parent toggle
                      toggleVertical("10") // Set active state for this tab only
                    }}
                  >
                    Calendar Access
                  </NavLink>
                </NavItem>

                <NavItem>
                  <NavLink
                    style={{ cursor: "pointer" }}
                    className={classnames({
                      active: verticalActiveTab === "11",
                    })}
                    onClick={e => {
                      e.stopPropagation()
                      toggleVertical("11")
                    }}
                  >
                    LinkedIn Accounts
                  </NavLink>
                </NavItem>

                <NavItem>
                  <NavLink
                    style={{ cursor: "pointer" }}
                    className={classnames({
                      "mb-2": true,
                      active: verticalActiveTab === "15",
                    })}
                    onClick={(e) => {
                      e.stopPropagation();
                      toggleVertical("15");
                    }}
                  >
                    Manage AI Key
                  </NavLink>
                </NavItem>

                <NavItem>
                  <NavLink
                    style={{ cursor: "pointer" }}
                    className={classnames({
                      "mb-2": true,
                      active: verticalActiveTab === "16",
                    })}
                    onClick={(e) => {
                      e.stopPropagation();
                      toggleVertical("16");
                    }}
                  >
                    Alert Settings
                  </NavLink>
                </NavItem>

                <NavItem>
                  <NavLink
                    style={{ cursor: "pointer" }}
                    className={classnames({
                      "mb-2": true,
                      active: verticalActiveTab === "17",
                    })}
                    onClick={(e) => {
                      e.stopPropagation();
                      toggleVertical("17");
                    }}
                  >
                    Assessment View
                  </NavLink>
                </NavItem>
              </Nav>
            </Col>
            <Col md="10">
              <div className="bg-transparent mb-0">
                <TabContent
                  activeTab={verticalActiveTab}
                  className="text-muted mt-4 mt-md-0"
                >
                  <TabPane tabId="1">
                    <Credentials />
                  </TabPane>
                  <TabPane tabId="2">
                    <Form>
                      <div
                        className={`flex-column fixed-buttons pt-2 ${fixedContent ? "d-flex" : "d-none"
                          }`}
                      >
                        <button
                          onClick={() => {
                            tog_center()
                          }}
                          className="btn btn-save btn-label pe-0  fix-btn "
                        >
                          <i className="fas fa-plus me-2 icon-size label-icon"></i>
                          <span>Add</span>
                        </button>
                        <button
                          onClick={() => navigate(-1)}
                          className="btn btn-red  fix-btn btn-label pe-0"
                        >
                          <i className="dripicons-cross me-2 icon-center label-icon"></i>
                          <span>Cancel</span>
                        </button>
                      </div>
                      <div className="p-4 bg-white shadow">
                        <div className="row">
                          <div className="col-md-9">
                            <h5 className="text-dark">Gitlab</h5>
                          </div>
                          <div className="col-md-3">
                            <button
                              onClick={() => {
                                tog_center()
                              }}
                              className=" btn btn-save btn-label"
                            >
                              {" "}
                              <i className="fas fa-save me-2 icon-size label-icon"></i>
                              Save
                            </button>
                            <a
                              onClick={() => navigate(-1)}
                              className=" btn ms-md-2 btn-red btn-label"
                            >
                              <i className="dripicons-cross me-2 icon-center label-icon"></i>
                              CANCEL
                            </a>
                          </div>
                        </div>

                        <Row className="">
                          <div className="mt-4 col-md-6">
                            <label htmlFor="">Token</label>
                            <input
                              type="text"
                              placeholder="Enter Token"
                              className="form-control "
                            />
                          </div>
                          <div className="mt-4 col-md-6">
                            <label htmlFor="">User Id</label>
                            <input
                              type="text"
                              placeholder="Enter User Id"
                              className="form-control "
                            />
                          </div>
                        </Row>
                      </div>
                    </Form>
                  </TabPane>
                  <TabPane tabId="3">
                    <Form onSubmit={addEditTechnologies}>
                      <div className=" p-4 bg-white shadow">
                        <div className="d-flex justify-content-between">
                          <div>
                            <h5 className="pt-2 text-dark fw-bold">
                              Technologies
                            </h5>
                          </div>
                          <div className="d-flex justify-content-end">
                            <div
                              className={`flex-column fixed-buttons ${fixedContent ? "d-flex" : "d-none"
                                }`}
                            >
                              <button
                                onClick={() => onAddRow()}
                                className="btn btn-save fix-btn"
                              >
                                <i className="fas fa-plus me-2 icon-size"></i>
                                <span>Add</span>
                              </button>
                              <button
                                type="submit"
                                className="btn btn-save fix-btn"
                              >
                                <i className="fas fa-save me-2"></i>
                                <span> Save</span>
                              </button>
                            </div>
                            <div>
                              <div className="text-end d-flex">
                                <div className="">
                                  <div className="me-4">
                                    <div className="search-box me-xxl-2 my-xxl-0 d-inline-block">
                                      <div className="position-relative">
                                        <label
                                          htmlFor="search-bar-0"
                                          className="search-label"
                                        >
                                          <span
                                            id="search-bar-0-label"
                                            className="sr-only"
                                          >
                                            Search this table
                                          </span>
                                          <input
                                            onChange={e => {
                                              setSearchTerm(e.target.value)
                                              filterGlobel()
                                            }}
                                            id="search-bar-0"
                                            type="text"
                                            className=" form-control rounded h-100"
                                            placeholder={` Search...`}
                                            value={searchTerm}
                                          />
                                        </label>
                                        <i className="bx bx-search-alt search-icon"></i>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div>
                                  <a
                                    onClick={() => onAddRow()}
                                    className="btn btn-purple  mr-3 btn-label"
                                  >
                                    <i className="fas fa-plus me-2 icon-size label-icon"></i>{" "}
                                    Add Technologies
                                  </a>
                                </div>
                                <div>
                                  <button
                                    type="submit"
                                    className="btn btn-save btn-label"
                                  >
                                    <i className="fas fa-save me-2 label-icon"></i>
                                    Save
                                  </button>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div className="responsive-table table-responsive">
                          <Table className="table table-bordered mb-0 table-striped mt-3 table-hover">
                            <thead>
                              <tr>
                                <th className="text-center tech-price">Id</th>
                                <th className="tech-price1">Technologies</th>
                                <th
                                  className="tech-price text-center"
                                  style={{ minWidth: "130px" }}
                                >
                                  Status
                                </th>
                                {currency?.map((curry, i) => (
                                  <th key={i} className="tech-price">
                                    {curry.currency}
                                  </th>
                                ))}
                                <th className="text-center tech-price"></th>
                              </tr>
                            </thead>
                            <tbody>
                              {(testingRows || [])
                                ?.map((testingRow, key) => (
                                  <tr key={testingRow.id}>
                                    <td className="text-center">{key + 1}</td>
                                    {/* <td className="">
                                      <input
                                        type="text"
                                        className="form-control "
                                        value={inputData[key]?.Technology}
                                        onChange={e =>
                                          handleFormChange(
                                            key,
                                            "Technology",
                                            e.target.value
                                          )
                                        }
                                      />
                                    </td> */}
                                    <td className="">
                                      <input
                                        type="text"
                                        className="form-control "
                                        value={inputData[key]?.Technology}
                                        onChange={e =>
                                          handleFormChange(
                                            key,
                                            "Technology",
                                            e.target.value
                                          )
                                        }
                                      />
                                    </td>
                                    <td>
                                      <select
                                        className="form-select"
                                        value={
                                          inputData[key]?.status || "optional"
                                        }
                                        onChange={e =>
                                          handleFormChange(
                                            key,
                                            "status",
                                            e.target.value
                                          )
                                        }
                                      >
                                        {STATUS_OPTIONS.map(opt => (
                                          <option key={opt} value={opt}>
                                            {opt}
                                          </option>
                                        ))}
                                      </select>
                                    </td>
                                    {currency?.map((curry, index) => {
                                      return (
                                        <td className="" key={index}>
                                          <input
                                            type="text"
                                            className="form-control"
                                            defaultValue={
                                              testingRow.currency_value
                                            }
                                            value={
                                              inputData[key][curry.currency]
                                            }
                                            onChange={e =>
                                              handleFormChange(
                                                key,
                                                curry.currency,
                                                e.target.value
                                              )
                                            }
                                          />
                                        </td>
                                      )
                                    })}
                                    <td className="text-center">
                                      {key !== 0 ? (
                                        <a
                                          onClick={() =>
                                            onDeleteRow(testingRow.id)
                                          }
                                          className="btn btn-outline-danger"
                                        >
                                          <i className="fas fa-trash-alt"></i>
                                        </a>
                                      ) : (
                                        "--"
                                      )}
                                    </td>
                                  </tr>
                                ))
                                .reverse()}

                              {testingRows.length === 0 && (
                                <tr>
                                  <td colSpan={8} className="text-center">
                                    No data found
                                  </td>
                                </tr>
                              )}
                            </tbody>
                          </Table>
                        </div>
                      </div>
                    </Form>
                  </TabPane>

                  <TabPane tabId="12">
                    <div className="p-4 bg-white shadow">
                      {/* Header */}
                      <div className="d-flex justify-content-between align-items-center mb-2">
                        <h5 className="pt-2 text-dark fw-bold d-flex align-items-center gap-3">
                          Overhead
                          <span
                            className="d-flex align-items-center gap-2"
                            style={{
                              background: "#f0e6f6",
                              color: "#752a97",
                              fontWeight: 600,
                              fontSize: "13px",
                              borderRadius: "20px",
                              padding: "5px 14px",
                            }}
                          >
                            Total Hourly Overhead:
                            <select
                              className="form-select form-select-sm"
                              style={{
                                width: "85px",
                                color: "#752a97",
                                border: "1px solid #c89ee0",
                                borderRadius: "8px",
                                fontSize: "12px",
                                padding: "2px 6px",
                                background: "#fff",
                                fontWeight: 600,
                              }}
                              value={
                                selectedOverheadCurrency ||
                                currency?.[0]?.currency ||
                                ""
                              }
                              onChange={e =>
                                setSelectedOverheadCurrency(e.target.value)
                              }
                            >
                              {currency?.map((c, i) => (
                                <option key={i} value={c.currency}>
                                  {c.currency}
                                </option>
                              ))}
                            </select>
                            {filteredOverheadRows
                              .reduce(
                                (sum, r) =>
                                  sum +
                                  (parseFloat(
                                    r[
                                    selectedOverheadCurrency ||
                                    currency?.[0]?.currency
                                    ]
                                  ) || 0),
                                0
                              )
                              .toFixed(2)}
                          </span>
                        </h5>
                        <div className="d-flex gap-2 align-items-center">
                          {/* Search */}
                          <div className="search-box me-2 d-inline-block">
                            <div className="position-relative">
                              <label
                                htmlFor="overhead-search"
                                className="search-label"
                              >
                                <input
                                  id="overhead-search"
                                  type="text"
                                  className="form-control rounded"
                                  placeholder="Search..."
                                  value={overheadSearch}
                                  onChange={e =>
                                    setOverheadSearch(e.target.value)
                                  }
                                />
                              </label>
                              <i className="bx bx-search-alt search-icon"></i>
                            </div>
                          </div>
                          {/* Add Row */}
                          <a
                            onClick={onAddOverheadRow}
                            className="btn btn-purple btn-label"
                          >
                            <i className="fas fa-plus me-2 icon-size label-icon"></i>
                            Add Overhead
                          </a>
                        </div>
                      </div>

                      {/* Per-User Overhead Formula */}
                      <div
                        className="d-flex align-items-center justify-content-between px-4 py-3"
                        style={{
                          background: "linear-gradient(135deg, #f8f0ff 0%, #fff 100%)",
                          border: "1.5px solid #d9b8f0",
                          borderRadius: "14px",
                          boxShadow: "0 2px 8px rgba(117,42,151,0.07)",
                        }}
                      >
                        {/* Label */}
                        <div className="d-flex align-items-center gap-2">
                          <div
                            style={{
                              width: "32px",
                              height: "32px",
                              borderRadius: "50%",
                              background: "linear-gradient(135deg, #752a97, #b06fd8)",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                            }}
                          >
                            <i className="fas fa-user" style={{ color: "#fff", fontSize: "13px" }} />
                          </div>
                          <span style={{ color: "#752a97", fontWeight: 700, fontSize: "14px", letterSpacing: "0.3px" }}>
                            Per User Overhead
                          </span>
                        </div>

                        {/* Formula */}
                        <div className="d-flex align-items-start gap-3">
                          {/* Total */}
                          <div className="d-flex flex-column align-items-center gap-1">
                            <span
                              style={{
                                background: "#fff",
                                border: "1.5px solid #c89ee0",
                                borderRadius: "8px",
                                padding: "5px 14px",
                                color: "#752a97",
                                fontWeight: 700,
                                fontSize: "14px",
                                minWidth: "100px",
                                textAlign: "center",
                                boxShadow: "0 1px 4px rgba(117,42,151,0.08)",
                              }}
                            >
                              {filteredOverheadRows
                                .reduce(
                                  (sum, r) =>
                                    sum + (parseFloat(r[selectedOverheadCurrency || currency?.[0]?.currency]) || 0),
                                  0
                                )
                                .toFixed(2)}{" "}
                              {selectedOverheadCurrency || currency?.[0]?.currency}
                            </span>
                            <span style={{ fontSize: "10px", color: "#aaa", fontWeight: 500, letterSpacing: "0.3px" }}>
                              Total Overhead
                            </span>
                          </div>

                          {/* Divider symbol */}
                          <div
                            style={{
                              width: "30px",
                              height: "30px",
                              borderRadius: "50%",
                              background: "#f0e6f6",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              fontWeight: 800,
                              fontSize: "16px",
                              color: "#752a97",
                              flexShrink: 0,
                              marginTop: "3px",
                            }}
                          >
                            ÷
                          </div>

                          {/* Staff Count */}
                          <div className="d-flex flex-column align-items-center gap-1">
                            <span
                              style={{
                                background: "#f0e6f6",
                                border: "1.5px solid #c89ee0",
                                borderRadius: "8px",
                                padding: "5px 14px",
                                color: "#752a97",
                                fontWeight: 700,
                                fontSize: "14px",
                                minWidth: "60px",
                                textAlign: "center",
                                boxShadow: "0 1px 4px rgba(117,42,151,0.08)",
                              }}
                            >
                              {staffCount || 0}
                            </span>
                            <span style={{ fontSize: "10px", color: "#aaa", fontWeight: 500, letterSpacing: "0.3px" }}>
                              Active Users
                            </span>
                          </div>

                          {/* Equals symbol */}
                          <div
                            style={{
                              width: "30px",
                              height: "30px",
                              borderRadius: "50%",
                              background: "#f0e6f6",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              fontWeight: 800,
                              fontSize: "16px",
                              color: "#752a97",
                              flexShrink: 0,
                              marginTop: "3px",
                            }}
                          >
                            =
                          </div>

                          {/* Result */}
                          <div className="d-flex flex-column align-items-center gap-1">
                            <span
                              style={{
                                background: "linear-gradient(135deg, #752a97, #b06fd8)",
                                color: "#fff",
                                borderRadius: "8px",
                                padding: "5px 18px",
                                fontWeight: 700,
                                fontSize: "14px",
                                minWidth: "110px",
                                textAlign: "center",
                                boxShadow: "0 2px 8px rgba(117,42,151,0.25)",
                              }}
                            >
                              {staffCount && parseInt(staffCount) > 0
                                ? Math.ceil(
                                  filteredOverheadRows.reduce(
                                    (sum, r) =>
                                      sum + (parseFloat(r[selectedOverheadCurrency || currency?.[0]?.currency]) || 0),
                                    0
                                  ) / parseInt(staffCount)
                                )
                                : "—"}{" "}
                              {selectedOverheadCurrency || currency?.[0]?.currency}
                            </span>
                            <span style={{ fontSize: "10px", color: "#aaa", fontWeight: 500, letterSpacing: "0.3px" }}>
                              Per User / Hour
                            </span>
                          </div>
                        </div>
                      </div>

                      {/* Table */}
                      <div className="table-responsive">
                        <Table className="table table-bordered table-striped table-hover mt-3 mb-0">
                          <thead>
                            <tr>
                              <th
                                className="text-center"
                                style={{ width: "100px" }}
                              >
                                Id
                              </th>
                              <th>Overhead</th>
                              {currency?.map((curry, i) => (
                                <th key={i} className="tech-price">
                                  {curry.currency}
                                </th>
                              ))}

                              <th
                                className="text-center"
                                style={{ width: "150px" }}
                              >
                                Action
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            {filteredOverheadRows.length === 0 ? (
                              <tr>
                                <td
                                  colSpan={3 + (currency?.length || 0)}
                                  className="text-center"
                                >
                                  No data found
                                </td>
                              </tr>
                            ) : (
                              filteredOverheadRows.map((row, index) => (
                                <tr key={index}>
                                  <td className="text-center">{index + 1}</td>

                                  {/* Name */}
                                  <td>
                                    <input
                                      type="text"
                                      className="form-control"
                                      placeholder="Enter overhead name"
                                      value={row.name || ""}
                                      onChange={e =>
                                        handleOverheadChange(
                                          index,
                                          "name",
                                          e.target.value
                                        )
                                      }
                                    />
                                  </td>

                                  {/* Dynamic currency columns */}
                                  {currency?.map((curry, ci) => (
                                    <td key={ci}>
                                      <input
                                        type="number"
                                        className="form-control"
                                        placeholder="0.00"
                                        value={row[curry.currency] || ""}
                                        onChange={e =>
                                          handleOverheadChange(
                                            index,
                                            curry.currency,
                                            e.target.value
                                          )
                                        }
                                      />
                                    </td>
                                  ))}

                                  {/* Actions */}
                                  <td className="text-center">
                                    <div className="d-flex gap-2 justify-content-center">
                                      <a
                                        onClick={() =>
                                          saveOverheadRow(row, index)
                                        }
                                        className="btn btn-save btn-sm"
                                        title="Save"
                                      >
                                        <i className="fas fa-save"></i>
                                      </a>
                                      <a
                                        onClick={() =>
                                          deleteOverheadRow(row, index)
                                        }
                                        className="btn btn-outline-danger btn-sm"
                                        title="Delete"
                                      >
                                        <i className="fas fa-trash-alt"></i>
                                      </a>
                                    </div>
                                  </td>
                                </tr>
                              ))
                            )}
                          </tbody>
                          {filteredOverheadRows.length > 0 && (
                            <tfoot>
                              <tr
                                style={{
                                  background: "#f0e6f6",
                                  fontWeight: 600,
                                }}
                              >
                                <td
                                  colSpan={2}
                                  className="text-end pe-3"
                                  style={{ color: "#752a97" }}
                                >
                                  Total
                                </td>
                                {currency?.map((curry, i) => (
                                  <td
                                    key={i}
                                    className="text-center"
                                    style={{ color: "#752a97" }}
                                  >
                                    {filteredOverheadRows
                                      .reduce(
                                        (sum, r) =>
                                          sum +
                                          (parseFloat(r[curry.currency]) || 0),
                                        0
                                      )
                                      .toFixed(2)}
                                  </td>
                                ))}
                                <td></td>
                              </tr>
                            </tfoot>
                          )}
                        </Table>
                      </div>
                    </div>
                  </TabPane>
                  <TabPane tabId="4">
                    <GeneralTaskSetting
                      verticalActiveTabs={verticalActiveTab}
                    />
                  </TabPane>
                  <TabPane tabId="5">
                    <GeneralTaskSetting
                      verticalActiveTabs={verticalActiveTab}
                    />
                  </TabPane>

                  <TabPane tabId="6">
                    <AccessActivityIndex
                      verticalActiveTabs={verticalActiveTab}
                    />
                  </TabPane>
                  <TabPane tabId="9">
                    <LeadCommunicatorIndex
                      verticalActiveTabs={verticalActiveTab}
                    />
                  </TabPane>
                  <TabPane tabId="10">
                    <CalenderAccessIndex
                      verticalActiveTabs={verticalActiveTab}
                    />
                  </TabPane>

                  <TabPane tabId="11">
                    <LinkedinIndex verticalActiveTabs={verticalActiveTab} />
                  </TabPane>
                  <TabPane tabId="15">
                    <ManageAiKeyIndex />
                  </TabPane>
                  <TabPane tabId="16">
                    <AlertSettingsIndex />
                  </TabPane>
                  <TabPane tabId="17">
                    <AssessmentViewSettings />
                  </TabPane>
                </TabContent>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
      {/*  */}

      {swalconfirm && (
        <div className="swal-confirm-popup-genral-setting">
          <div className="bg-white pb-3 pt-2 px-4 -swal-22">
            <div
              className="swal2-icon swal2-success swal2-icon-show"
              style={{ display: "flex" }}
            >
              <div
                className="swal2-success-circular-line-left"
                style={{ backgroundColor: "rgb(255, 255, 255)" }}
              ></div>
              <span className="swal2-success-line-tip"></span>
              <span className="swal2-success-line-long"></span>
              <div className="swal2-success-ring"></div>
              <div
                className="swal2-success-fix"
                style={{ backgroundColor: "rgb(255, 255, 255)" }}
              ></div>
              <div
                className="swal2-success-circular-line-right"
                style={{ backgroundColor: "rgb(255, 255, 255)" }}
              ></div>
            </div>
            <h2
              className="swal22-title "
              id="swal2-title"
              style={{ display: "block" }}
            >
              Technologies Saved Successfully
            </h2>
            <div className="d-flex justify-content-center py-3">
              <button
                type="button"
                className="py-2 px-3"
                aria-label=""
                style={{ display: "inline-block" }}
                onClick={() => setSwalconfirm(false)}
              >
                OK
              </button>
            </div>
          </div>
        </div>
      )}
    </React.Fragment>
  )
}

export default GeneralSettingIndex
